<template>
  <div class="px-7" ref="subMenuErosionRef">
    <v-btn-toggle
      v-model="erosion"
      mandatory
      style="border: 1px solid #95a1ec"
      background-color="#212a35"
      :class="width > 300 ? 'd-flex flex-row' : 'd-flex flex-column'"
    >
      <v-btn
        :value="'Erodibilidade'"
        color="#95A1EC"
        class="btn-group flex-grow-1"
        height="28"
      >
        Erodibilidade
      </v-btn>
      <v-btn
        :value="'Susceptibilidade'"
        color="#95A1EC"
        class="btn-group flex-grow-1"
        height="28"
      >
        Susceptibilidade
      </v-btn>
      <v-btn
        :value="'Vulnerabilidade'"
        color="#95A1EC"
        class="btn-group flex-grow-1"
        height="28"
      >
        Vulnerabilidade
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'SubMenuLayerErosion',
  props: ['layer', 'group'],

  data: () => ({
    erosion: undefined,
    width: 0,
    observer: null,
  }),
  mounted() {
    this.observer = new ResizeObserver(this.handleResize);
    this.observer.observe(this.$refs.subMenuErosionRef);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  watch: {
    erosion() {
      this.changeLayersOfErosion();
    },
  },
  methods: {
    handleResize(entries) {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.width = width;
      }
    },
    changeLayersOfErosion() {
      if (this.erosion == 'Erodibilidade') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 737},
        });

        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 736},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 735},
        });
      }

      if (this.erosion == 'Susceptibilidade') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 735},
        });

        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 737},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 736},
        });
      }

      if (this.erosion == 'Vulnerabilidade') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 735},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 736},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 737},
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-transform: none;
  color: #95a1ec;
  border: 1px solid #95a1ec;
}

::v-deep .theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #95a1ec !important;
}

::v-deep .v-btn-toggle > .v-btn.v-btn--active {
  color: #95a1ec !important;
  opacity: 1;
}

::v-deep .theme--dark.v-btn.v-btn--has-bg {
  background-color: #212a35 !important;
}
</style>
